module.exports = __webpack_public_path__ + "img/middle_on.79000150.png";